import { css, Interpolation, Theme } from '@emotion/react'
import { buttonBaseClasses, outlinedInputClasses } from '@mui/material'

export const cell: Interpolation<Theme> = (theme: Theme) => css`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
`

export const value: Interpolation<Theme> = (theme: Theme) => css`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};

  svg {
    height: 20px;
    width: 20px;
    min-width: 20px;
  }
`

export const input: Interpolation<Theme> = (theme: Theme) => css`
  width: 100%;

  .${outlinedInputClasses.root} {
    border: none;
    box-shadow: none;

    background-color: ${theme.colors.backgroundOne};
  }
`

export const iconButton: Interpolation<Theme> = css`
  &.${buttonBaseClasses.root} {
    height: 36px;
    width: 36px;
    min-width: 36px;
    padding: 0;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`
